export default __webpack_public_path__ + "static/Healing-0ca27b88e20cec9991b22e1135e9f0f8.png";